<script>
import ServiceReminderService from "../../../services/ServiceReminderService";

export default {
    name: "StatusComponent",
    props: {
        reminder: {
            type: Object,
            required: true,
        },
    },
    data: function () {
        return {
            status: undefined,
        };
    },
    watch: {
        reminder: {
            handler(newVal) {
                this.status = newVal.status;
            },
            immediate: true,
        },
    },
    methods: {
        statusChanged($event) {
            this.$emit("input", $event.target.value);
            this.status = $event.target.value;
            ServiceReminderService.update({
                ...this.reminder,
                status: $event.target.value,
            }).then((res) => {});
        },
    },
}
</script>

<template>
    <select
        name="status"
        id=""
        v-model="status"
        @input="statusChanged($event)"
        class="form-control"
    >
        <option value="due">
            Due
        </option>
        <option value="booked">
            Booked
        </option>
        <option value="ok any">
            OK Any
        </option>
        <option value="done">
            Done
        </option>
        <option value="no access">
            No Access
        </option>
    </select>
</template>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/office/service-reminders/StatusComponent.vue